import { render, staticRenderFns } from "./InterpretationRequest.vue?vue&type=template&id=9562e28e&scoped=true"
import script from "./InterpretationRequest.vue?vue&type=script&lang=js"
export * from "./InterpretationRequest.vue?vue&type=script&lang=js"
import style0 from "./InterpretationRequest.vue?vue&type=style&index=0&id=9562e28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9562e28e",
  null
  
)

export default component.exports